import { find, orderBy } from 'lodash'
import PropTypes from 'prop-types'
import React, { useMemo } from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import { createIconMaterialState } from '../../../utils/MaterielUtils'
import DtoMaterielSituation from '../../dto/DtoMaterielSituation'
import { Grid2 } from '@mui/material'

const LastSituationMarkerPanel = ({ materielSituation }) => {
    const {
        materielStates,
    } = useSelector(store => ({
        materielStates: store.MaterielReducer.materielStates,
    }), shallowEqual)

    const lastState = useMemo(() => {
        if (materielSituation.length) {
            const orderSituation = orderBy(materielSituation, 'id', 'desc')
            const lastSituation = orderSituation[0]
            if (lastSituation.statusCode) {
                const findState = find(materielStates, (o) => {
                    return o.id === lastSituation.statusCode
                })
                if (findState) {
                    return createIconMaterialState(findState.label, findState.code, '8rem', false)
                }
                return null
            }
            return null
        }
        return null
    }, [materielSituation])

    if (lastState) {
        return (
            <Grid2 container size={12} alignItems={'center'}>
                { lastState }
            </Grid2>
        )
    }
    return null
}

LastSituationMarkerPanel.propTypes = {
    materielSituation: PropTypes.arrayOf(PropTypes.instanceOf(DtoMaterielSituation)),
}

export default LastSituationMarkerPanel